// extracted by mini-css-extract-plugin
export var productImage = "_l3-1";
export var viewLink = "_l3-2";
export var wishlistItem = "_l3-0";